exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2nhzB{background:#fff;border-top:1px solid #efefef;color:#313131;opacity:.8;margin-top:48px;margin-top:3rem}._3aBnd{padding:1em 0}@media (min-width:578px){._3aBnd{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}}@media (min-width:578px){._3aBnd,._36Xgk{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex}}.NoJN3{display:block;color:inherit;text-decoration:none}@media (min-width:578px){.NoJN3{padding-left:1em}}._1W3uT{display:inherit;width:90px}@media (min-width:370px){._1W3uT{width:120px}}", ""]);

// exports
exports.locals = {
	"footer": "_2nhzB",
	"wrap": "_3aBnd",
	"nav": "_36Xgk",
	"link": "NoJN3",
	"logo": "_1W3uT"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-rules-2!./node_modules/postcss-loader/lib??ref--1-rules-3!./node_modules/sass-loader/lib/loader.js!./src/components/Footer/Footer.scss
// module id = 644
// module chunks = 0 1 2 3 4 5 6 7 8 9 10